@if (groups()?.length) {
  <mat-tab-group [disableRipple]="true">
    @for (group of groups(); track group) {
      <mat-tab [labelClass]="'spec-params_tab'" [label]="group">
        <ng-container [ngTemplateOutlet]="specGroupForm" [ngTemplateOutletContext]="{ $implicit: group }"></ng-container>
      </mat-tab>
    }
  </mat-tab-group>
} @else {
  <ng-template [ngTemplateOutlet]="specGroupForm" [ngTemplateOutletContext]="{ $implicit: '' }"></ng-template>
}

<ng-template #specGroupForm let-group="$implicit">
  <form [formGroup]="specFormGroup()">
    @for (params of specParameters(); track trackByFn($index, params.key)) {
      @let fieldInfo = fieldInfoMap().get(params.key);

      @if (fieldInfo && shouldShowParam(showHiddenFields(), fieldInfo, groups(), group)) {
        <div class="format-view-shared_field">
          @if (fieldInfo.dropdown?.selectionType === 'multiple') {
            <span class="format-view-shared_field-label">
              {{ fieldInfo.name }}
              @if (fieldInfo.description) {
                <celum-icon [configuration]="infoIcon" [matTooltip]="fieldInfo.description" [matTooltipClass]="'formats-multiline-tooltip'"></celum-icon>
              }
            </span>
            <mat-form-field celum-form-field size="medium" class="format-view-shared_field--bg-white" [reserveHintSpace]="true">
              <input matInput type="text" [formControl]="params.key | wrapFn: getSearchControl" [matAutocomplete]="auto" />
              <celum-icon matSuffix [configuration]="arrowIcon"></celum-icon>
              <mat-autocomplete #auto="matAutocomplete" class="spec-params_multi-select-panel">
                @for (option of params.key | wrapFn: getFilteredOptions; track option) {
                  <mat-option class="spec-params_multi-select-option">
                    <celum-checkbox-item
                      orientation="row"
                      [attr.data-test-spec-multiselect-field-option]="option"
                      [checked]="(this.selectedValuesSignals.get(params.key)?.() ?? []).includes(option)"
                      [showToolTip]="false"
                      [text]="option"
                      (click)="$event.stopPropagation()"
                      (selectionChanged)="toggleOption(params.key, option, $event.checked)" />
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <celum-chip-set
              [showClearAll]="(selectedValuesSignals.get(params.key)?.() ?? []).length > 0"
              (clearAllClicked)="specFormGroup().get(params.key)?.setValue([])">
              @for (item of selectedValuesSignals.get(params.key)?.() ?? []; track item) {
                <celum-chip [text]="item" (remove)="removeChip(params.key, item)" />
              }
            </celum-chip-set>
          } @else if (fieldInfo.dropdown) {
            <span class="format-view-shared_field-label">
              {{ fieldInfo.name }}
              @if (fieldInfo.description) {
                <celum-icon [configuration]="infoIcon" [matTooltip]="fieldInfo.description" [matTooltipClass]="'formats-multiline-tooltip'"></celum-icon>
              }
            </span>
            <mat-form-field celum-form-field size="medium" class="format-view-shared_field--bg-white" [reserveHintSpace]="true">
              <mat-select
                [attr.data-test-spec-field]="params.key"
                [formControlName]="params.key"
                [hideSingleSelectionIndicator]="true"
                [panelClass]="'format-view-shared_select-panel'">
                @if (fieldInfo.dropdown.showEmptyOption) {
                  <mat-option data-test-spec-field-options="__empty__" [value]="null">{{ 'FORMAT_VIEW_DIALOG.NONE' | translate }}</mat-option>
                }
                @for (option of fieldInfo.dropdown.values; track option) {
                  <mat-option [attr.data-test-spec-field-options]="option" [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
              @if (fieldInfo.unit) {
                <span class="format-view-shared_suffix">
                  {{ fieldInfo.unit }}
                </span>
              }
              <celum-icon [configuration]="arrowIcon" matSuffix></celum-icon>
              @if (specFormGroup().get(params.key).errors?.['required']) {
                <mat-error>
                  {{ 'VALIDATION.REQUIRED' | translate }}
                </mat-error>
              }
              @if (specFormGroup().get(params.key).errors?.['pattern']) {
                <mat-error>
                  {{ 'VALIDATION.PATTERN' | translate }}
                </mat-error>
              }
            </mat-form-field>
          } @else if (fieldInfo.inputType === 'checkbox') {
            <mat-checkbox class="format-view-shared_field-label" labelPosition="before" [attr.data-test-spec-field]="params.key" [formControlName]="params.key">
              {{ fieldInfo.name }}
            </mat-checkbox>
          } @else {
            <span class="format-view-shared_field-label">
              {{ fieldInfo.name }}
              @if (fieldInfo.description) {
                <celum-icon [configuration]="infoIcon" [matTooltip]="fieldInfo.description" [matTooltipClass]="'formats-multiline-tooltip'"></celum-icon>
              }
            </span>
            <mat-form-field celum-form-field size="medium" class="format-view-shared_field--bg-white" [reserveHintSpace]="true">
              <input
                matInput
                [attr.data-test-spec-field]="params.key"
                [formControlName]="params.key"
                [type]="fieldInfo.inputType"
                [placeholder]="fieldInfo.placeholder" />
              @if (fieldInfo.unit) {
                <span matSuffix class="format-view-shared_suffix">{{ fieldInfo.unit }}</span>
              }

              @if (fieldInfo.example) {
                <mat-hint>e.g., {{ fieldInfo.example }}</mat-hint>
              }

              @if (specFormGroup().get(params.key).errors?.['required']) {
                <mat-error>{{ 'VALIDATION.REQUIRED' | translate }}</mat-error>
              }

              @if (specFormGroup().get(params.key).errors?.['pattern']) {
                <mat-error>{{ 'VALIDATION.PATTERN' | translate }}</mat-error>
              }
            </mat-form-field>
          }
        </div>
      }
    }
  </form>
</ng-template>
